import { render, staticRenderFns } from "./OverviewCard.vue?vue&type=template&id=f7c23fb0&scoped=true"
import script from "./OverviewCard.vue?vue&type=script&lang=js"
export * from "./OverviewCard.vue?vue&type=script&lang=js"
import style0 from "./OverviewCard.vue?vue&type=style&index=0&id=f7c23fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c23fb0",
  null
  
)

export default component.exports